// Kitchen Tablet delivery scan. Uses the background extraction job (prepared image + second read, 200 s
// budget) under the PIN-verified person's short-lived session, and falls back to the legacy synchronous
// endpoint only when the server does not offer jobs (older backend). The result is a proposal for review.
import { startExtractJob, pollExtractJob, JOB_WAIT_MS } from "@/lib/extractJob";

const statusOf = (e) => e?.normalized?.status ?? e?.response?.status;

export async function tabletExtract({ client, fileId, siteId, sessionExpiresAt, isCancelled }) {
  const body = { file_id: fileId, feature: "delivery_extraction", site_id: siteId || undefined };
  let job;
  try {
    // same photo -> same key -> the SAME job, so re-scanning after a timeout collects the running result
    job = await startExtractJob({ fileId, siteId, clientKey: `kt_${fileId}` }, { client });
  } catch (e) {
    if ([404, 405].includes(statusOf(e))) return { data: (await client.post("/ai/extract-document", body)).data, legacy: true };
    throw e;
  }
  if (job.status !== "done" && job.status !== "failed") {
    // never poll past the PIN session; the job itself carries on server-side
    const left = (sessionExpiresAt || Date.now() + JOB_WAIT_MS) - Date.now() - 5000;
    job = await pollExtractJob(job.job_id, { client, isCancelled, maxWaitMs: Math.max(0, Math.min(JOB_WAIT_MS, left)) });
  }
  if (job.status === "done") return { data: job.result || {} };
  const err = new Error(job.error?.msg || "Could not scan — enter details manually");
  err.code = job.error?.code;
  throw err;
}
